import { useState } from 'react';
import { Save } from 'lucide-react';
import { Btn, SelectField } from '../shared';
import { api, POSITIONS } from '../../lib/api';
import { passportError } from '../../lib/playerPassport';
import { PassportDialog } from './Primitives';
import { toast } from 'sonner';

export const PositionChoices = ({ value, onChange, id, legend = 'Positions played' }) => <fieldset className="pp-position-choices">
  <legend data-testid={`${id}-label`}>{legend}</legend>
  {POSITIONS.map((position, index) => <label key={position} className={value.includes(position) ? 'selected' : ''}>
    <input type="checkbox" data-testid={`${id}-${index}`} checked={value.includes(position)} onChange={e => onChange(e.target.checked ? [...value, position] : value.filter(p => p !== position))} />{position}
  </label>)}
</fieldset>;

export const BaseballDetails = ({ athlete, onClose, onSaved }) => {
  const [form, setForm] = useState({ positions: athlete.positions, bats: athlete.bats || '', throws: athlete.throws || '' });
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  const update = (key, value) => setForm(f => ({ ...f, [key]: value }));
  const save = async event => {
    event.preventDefault();
    if (!form.positions.length) { setError('Select at least one position.'); return; }
    setBusy(true); setError('');
    try { await api.patch(`/player-passports/${athlete.id}/baseball`, { ...form, bats: form.bats || null, throws: form.throws || null }); await onSaved(); toast.success('Baseball details saved'); onClose(); }
    catch (e) { setError(passportError(e)); } finally { setBusy(false); }
  };
  return <PassportDialog id="pp-baseball-modal" title="Baseball details" description={athlete.name} onClose={() => !busy && onClose()}>
    <form className="form-stack" onSubmit={save}>
      <PositionChoices id="pp-positions-choice" value={form.positions} onChange={value => update('positions', value)} />
      <div className="form-grid">
        <SelectField id="pp-bats-select" label="Bats" value={form.bats} onChange={e => update('bats', e.target.value)}><option value="">Not added</option>{['Left', 'Right', 'Switch'].map(v => <option key={v} value={v}>{v}</option>)}</SelectField>
        <SelectField id="pp-throws-select" label="Throws" value={form.throws} onChange={e => update('throws', e.target.value)}><option value="">Not added</option>{['Left', 'Right'].map(v => <option key={v} value={v}>{v}</option>)}</SelectField>
      </div>
      {error && <p className="error-notice" role="alert" data-testid="pp-baseball-error">{error}</p>}
      <div className="form-actions"><Btn secondary type="button" data-testid="pp-baseball-cancel" disabled={busy} onClick={onClose}>Cancel</Btn><Btn className="pp-primary" type="submit" data-testid="pp-baseball-save" disabled={busy}><Save />{busy ? 'Saving…' : 'Save details'}</Btn></div>
    </form>
  </PassportDialog>;
};